import React, { useState } from 'react';
import Panel from '../../components/ui/Panel';
import ChatBox from '../../components/ui/ChatBox';
import { ChatMessage } from '../../lib/ChatBox';
import { ChatChannelFilter } from '../../lib/chatColors';

const messages: ChatMessage[] = [
  { id: '1', channel: 'game', text: 'Welcome to Old School RuneScape.' },
  { id: '2', channel: 'public', author: 'Zezima', text: 'Buying rune ore.' },
  { id: '3', channel: 'private', author: 'Hans', text: 'I have been waiting here for 20 years.' },
  { id: '4', channel: 'friends', author: 'Channel', text: 'Meet at the grand exchange.' },
  { id: '5', channel: 'clan', author: 'Clan', text: 'Raid starts at the top of the hour.' },
  { id: '6', channel: 'trade', author: 'Trader', text: 'Selling sharks 800 ea.' },
];

const ChatPage: React.FC = () => {
  const [channel, setChannel] = useState<ChatChannelFilter>('all');
  const [log, setLog] = useState(messages);

  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Chat Interface</h1>
      <p className="text-osrs-yellow mb-8">
        Opaque chat sits on the tan chatbox. Game text is black there and yellow when the box is transparent. Public text is blue on opaque chat and light blue on transparent chat, matching the default colours on the OSRS settings page.
      </p>

      <section id="message-layout" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Message Layout</h2>
        <Panel>
          <ChatBox
            surface="transparent"
            messages={log}
            channel={channel}
            onChannelChange={setChannel}
            onSend={(text) => setLog((current) => [...current, { id: String(Date.now()), channel: 'public', author: 'You', text }])}
          />
        </Panel>
      </section>

      <section id="input-area" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Input Area</h2>
        <Panel>
          <p className="text-osrs-yellow mb-4">
            The line under the log is the message field. Press Enter to send. On a transparent box the caret line is yellow. On an opaque box it is blue.
          </p>
          <ChatBox
            surface="opaque"
            messages={messages}
            channel="all"
            onChannelChange={() => undefined}
            onSend={() => undefined}
          />
        </Panel>
      </section>

      <section id="channels" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Channels</h2>
        <Panel>
          <p className="text-osrs-yellow">
            The tabs along the bottom are All, Game, Public, Private, Channel, Clan, and Trade. Channel is friends chat. All shows every line. Any other tab keeps only that channel.
          </p>
        </Panel>
      </section>

      <section id="formatting" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Text Formatting</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Opaque game text is #000000. Transparent game text is #ffff00.</li>
            <li>Opaque public text is #0000ff. Transparent public text is #9090ff.</li>
            <li>Opaque private and friends text is #7f0000. Transparent private text is #bf2020. Transparent friends text is #ef5050.</li>
            <li>Trade requests are #7f007f on opaque chat and #df20ff on transparent chat.</li>
          </ul>
        </Panel>
      </section>

      <section id="usage-guidelines" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Usage Guidelines</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Use transparent for a chat overlay and opaque for the classic tan box.</li>
            <li>Do not recolour a channel away from the defaults unless the screen is showing a custom setting.</li>
            <li>Keep the channel tabs on one row so a player can filter without leaving the log.</li>
          </ul>
        </Panel>
      </section>
    </div>
  );
};

export default ChatPage;
